var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { getSnackBarsList } from '@returnmates/client-core/src/selectors/snacks';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import SnackBar from './components/SnackBar';
import useStyles from './styles';
var SnackBars = function () {
    var styles = useStyles({});
    var snacks = useSelector(getSnackBarsList);
    return (_jsx("div", __assign({ className: styles.root }, { children: snacks.map(function (snack, index) { return (_jsx(SnackBar, { snack: snack }, "".concat(snack.message).concat(index))); }) })));
};
export default memo(SnackBars);
//# sourceMappingURL=index.js.map